import { render, staticRenderFns } from "./BrakePadsDetail.vue?vue&type=template&id=45ee52ee&scoped=true"
import script from "./BrakePadsDetail.vue?vue&type=script&lang=js"
export * from "./BrakePadsDetail.vue?vue&type=script&lang=js"
import style0 from "./BrakePadsDetail.vue?vue&type=style&index=0&id=45ee52ee&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ee52ee",
  null
  
)

export default component.exports